// Standard discipline consequence types
export const DISCIPLINE_TYPES = {
  // Core types
  MENTION: 'mention',
  DEMERIT: 'demerit',
  DETENTION: 'detention',
  SUSPENSION: 'suspension',

  // Special variants (should be normalized to core types with metadata)
  FRIDAY_DETENTION: 'friday-detention',
  SATURDAY_DETENTION: 'saturday-detention',
  SUSPENSION_PENDING_REVIEW: 'suspension-pending-review',

  // System types
  WARNING: 'warning',
  NOTIFICATION: 'notification',
  ACCOUNTABILITY: 'accountability',
  CONTRACT_CONSEQUENCE: 'contract-consequence',
  DUPLICATE_RESOLUTION: 'duplicate-resolution',

  // Legacy types (for backward compatibility)
  CONSEQUENCE: 'consequence',
  MENTION_RULE_CONSEQUENCE: 'mention-rule-consequence'
};

// Allowed types for validation
export const ALLOWED_DISCIPLINE_TYPES = Object.values(DISCIPLINE_TYPES);

// Core types that should be used for new records
export const CORE_DISCIPLINE_TYPES = [
  DISCIPLINE_TYPES.DEMERIT,
  DISCIPLINE_TYPES.DETENTION,
  DISCIPLINE_TYPES.SUSPENSION
];